// extracted by mini-css-extract-plugin
export var site_layout_content = "layout-module--site_layout_content--1PzQj";
export var components_layout_demo_top = "layout-module--components_layout_demo_top--38n7a";
export var logo = "layout-module--logo---MXHy";
export var ant_row_rtl = "layout-module--ant_row_rtl--2iSod";
export var HeaderTitle = "layout-module--HeaderTitle--2TvwA";
export var antTypography = "layout-module--ant-typography--394F9";
export var gatsbyImageWrapper = "layout-module--gatsby-image-wrapper--MEouq";
export var spin = "layout-module--spin--18rNf";
export var rotate = "layout-module--rotate--1OCJw";